import { observer } from 'mobx-react';
import { Note } from '../../../../../../../../components/note/note';
import { BUTTON_VARIANTS } from '../../../../../../../../components/inputs/button-variants';
import FedexV2RegistrationStore from '../../../../../stores/credentials/shipping/fedex-v2/fedex-v2-registration-store';
import FedexV2RegistrationModalLayout from '../fedex-v2-registration-modal-layout';

interface IProps {
    registration: FedexV2RegistrationStore;
}

const FedexV2RegistrationCompleteModalStep: React.FC<IProps> = observer(({ registration }) => (
    <FedexV2RegistrationModalLayout
        registration={registration}
        buttons={[{
            text: 'Done',
            variant: BUTTON_VARIANTS.Primary,
            onClick: registration.close,
        }]}
    >
        <Note body="FedEx account registered successfully." />
    </FedexV2RegistrationModalLayout>
));

export default FedexV2RegistrationCompleteModalStep;
